import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumbersOnlySpecDirective } from './number-only-spec.directive';

@NgModule({
  declarations: [NumbersOnlySpecDirective],
  imports: [CommonModule],
  exports: [NumbersOnlySpecDirective],
})
export class NumberOnlySpecModule {}
